export enum Colors {
    PrimaryColor = '#77bb2b',
    PrimaryColorHover = '#426818',
    White = '#FFFFFF',
    MainFontColor = '#666666',
    MainFontColorHover = '#333333',
}
